import React, { useState } from 'react';
import EventForm from '../EventForm/Container'
import NewsBox from '../NewsBox'
import Modal from '../Modal'
import InputField from '../Inputs/InputField'
import { reduxForm, SubmissionError } from 'redux-form';
import ContactValidator from '../../validators/ContactValidator'
export default reduxForm({
    form: 'contact',
  //  validate: ContactValidator,
    enableReinitialize: true
})(({invalid, handleSubmit, reset, contactAction }) => {

    
    const [waiting, setWaiting] = useState(false)
    const [sent, setSent] = useState(false)
    
    const submit = (values, dispatch, props) => {
	let errors = ContactValidator( values, props ) || {};
	
	setWaiting(true)
	if (Object.keys(errors).length) {
	    setWaiting(false)
	    throw new SubmissionError(errors);
	} else {
    
	    contactAction(values).then((res) => {
		setWaiting(false)
		setSent(true)
		reset()
	    }).catch((err) => {
		setWaiting(false)
		
		setSent(false)
		console.log(err)})
	}
    }

    
    return <div>
	{sent === true ?
	 <h1>Hvala za kontat</h1>
	:
	 <React.Fragment>
	     <h1>PIŠI NAM</h1>

	     <form onSubmit={handleSubmit(submit)}>
		 <InputField name="full_name" type="text" label="Ime in priimek" />
		 <InputField name="email" type="text" label="Vaš e-mail" />
		 <InputField name="description" type="textarea2" label="Besedilo" />

		 <div style={{height: '50px'}}></div>
		 <button type="submit" disabled={invalid || waiting} className="btn btn-brown btn-big full-width" >
		     <i style={{display: (waiting ? 'inline-block' : 'none' )}} className="fa fa-spinner fa-spin"></i>
		     Pošlji
		 </button>
		 
		 <div style={{height: '100px'}}></div>
	     </form>
	 </React.Fragment>}
    </div>
})




// WEBPACK FOOTER //
// ./src/components/Contact/index.jsx